<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-07-11 10:47:12
 * @LastEditors: Betway huangbo@mrcdevlab.com
 * @LastEditTime: 2026-03-31 18:19:18
-->
<template>
  <div>
    <div class="drop_area" v-if="!file">
      <mrc_ess_fileInput
        :accept="accept"
        :uploadFileType="uploadFileType"
        @changeimgSrc="changeimgSrc"
      ></mrc_ess_fileInput>
      <v-icon class="material-icons mb-5" style="color: #e0e0e0; font-size: 71px">
        cloud_upload
      </v-icon>
      <span>
        <v-btn
          rounded
          height="40"
          depressed
          color="#C6DBFD"
          class="text-capitalize primary-text"
          :style="{
            padding: '0px 110px',
            'font-size': '14px',
            'font-weight': 600,
            color: $vuetify.theme.defaults.light.primary,
          }"
          dark
        >
          {{ $t("label_browse") }}
        </v-btn>
      </span>
      <!-- <span style="color: #a4a4a4;"
            class="mt-4">
        *{{$t('label_support')}} .xls / .xlsx / .csv
      </span> -->
      <!-- <span style="color: #a4a4a4;">
        *{{$t('label_pleaseUseTempleteUploadData')}}, <span @click="downloadTemplate"
              :style="{'color': $vuetify.theme.defaults.light.primary,'text-decoration': 'underline','position':'relative','z-index':10}">
          <a :href="hrefUrl"> {{$t('label_Download_the_template')}}</a>
        </span>
      </span> -->
      <span
        @click.stop="downloadTemplate"
        class="mt-4"
        :style="{
          color: $vuetify.theme.defaults.light.primary,
          'text-decoration': 'underline',
          position: 'relative',
          'z-index': 10,
        }"
      >
        <a :href="hrefUrl">{{ $t("label_Download_the_template") }}</a>
      </span>
    </div>
    <div class="bigbox" v-else>
      <div class="pr-7">
        <v-img
          src="https://ss0.bdstatic.com/94oJfD_bAAcT8t7mm9GUKT-xh_/timg?image&quality=100&size=b4000_4000&sec=1597893978&di=9be0dc838555883e5b844b5f785e1031&src=http://pic.veryhuo.com/uploads/allimg/1609/1-16091F919180-L.png"
          width="120"
          height="120"
          class="grey darken-4"
        ></v-img>
      </div>
      <div class="d-flex justify-space-between" style="width: 100%">
        <span>
          <span>{{ file.name }}</span>
          <br />
          <span>{{ file.size | unitConversion }}</span>
        </span>
        <span @click="deleteicon" style="position: relative; z-index: 10" class="pr-3">
          <v-icon>mdi-delete</v-icon>
        </span>
      </div>
    </div>
    <!-- 
       <v-list-group
        prepend-icon="account_circle"
        value="true"
      >
        <template v-slot:activator>
          <v-list-item-title>Users</v-list-item-title>
        </template>

        <v-list-group
          no-action
          sub-group
          value="true"
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Admin</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item
            v-for="(admin, i) in admins"
            :key="i"
            link
          >
            <v-list-item-title v-text="admin[0]"></v-list-item-title>
            <v-list-item-icon>
              <v-icon v-text="admin[1]"></v-icon>
            </v-list-item-icon>
          </v-list-item>
        </v-list-group>
     -->
  </div>
</template>

<script>
/**
 *  uploadFileType   验证规则 正则表达式
 *  accept   input接受文件规则
 *  file 返回的文件对象
 *  @downloadTemplate 下载模板点击事件
 */
export default {
  components: {},
  props: {
    uploadFileType: {
      default: () => {
        return /\.(xls|xlsx|csv)$/;
      },
    },
    accept: {
      type: String,
      default:
        "application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,text/csv",
    },
    file: {
      default: null,
    },
    hrefUrl: {
      type: String,
    },
  },
  model: {
    prop: "file",
    event: "changeFile",
  },
  filters: {
    unitConversion(v) {
      return (Number(v) / 1024 / 1024).toFixed(2) + "M";
    },
  },
  data() {
    return {};
  },
  computed: {},
  created() {},
  watch: {},
  mounted() {},
  methods: {
    deleteicon(v) {
      this.$emit("changeFile", null);
    },
    downloadTemplate() {
      this.$emit("downloadTemplate");
    },
    changeimgSrc(v) {
      this.$emit("changeFile", v[0]);
    },
  },
};
</script>

<style scoped>
.drop_area {
  position: relative;
  background-color: #ffffff;
  border: 4px dashed #e0e0e0;
  width: 100%;
  height: 190px;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 350px;
  justify-content: center;
  overflow: hidden;
}
.bigbox {
  position: relative;
  background-color: #ffffff;
  width: 100%;
  min-height: 150px;
  border: 4px solid #e0e0e0;
  padding-left: 8px;
  display: flex;
  justify-items: center;
  align-items: center;
}
</style>
